import React from 'react';
import { motion } from 'framer-motion';
import LeverancierCard from './ProviderCard';
import Icon from '../../../components/AppIcon';

const LeverancierGrid = ({ leveranciers, loading, error }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  // Loading State
  if (loading) {
    return (
      <section className="py-12 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6]?.map((i) => (
              <div key={i} className="bg-card border border-border rounded-xl p-6 animate-pulse">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="h-6 bg-muted rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-muted rounded w-1/2"></div>
                  </div>
                  <div className="w-10 h-10 bg-muted rounded-full"></div>
                </div>
                <div className="space-y-2 mb-4">
                  <div className="h-4 bg-muted rounded w-full"></div>
                  <div className="h-4 bg-muted rounded w-2/3"></div>
                </div>
                <div className="h-10 bg-muted rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // Error State
  if (error) {
    return (
      <section className="py-12 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-error/10 border border-error/20 rounded-xl p-8 text-center">
            <Icon name="AlertCircle" size={48} className="text-error mx-auto mb-4" />
            <h3 className="text-xl font-heading font-bold text-foreground mb-2">
              Er is iets misgegaan
            </h3>
            <p className="text-muted-foreground mb-4">{error}</p>
            <button
              onClick={() => window.location?.reload()}
              className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              Probeer opnieuw
            </button>
          </div>
        </div>
      </section>
    );
  }

  // Empty State
  if (!leveranciers || leveranciers?.length === 0) {
    return (
      <section className="py-12 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-muted/50 border border-border rounded-xl p-12 text-center">
            <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h3 className="text-xl font-heading font-bold text-foreground mb-2">
              Geen aanbieders gevonden
            </h3>
            <p className="text-muted-foreground">
              Probeer uw zoekopdracht of filters aan te passen
            </p>
          </div>
        </div>
      </section>
    );
  }

  // Leverancier Grid
  return (
    <section className="py-12 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {leveranciers?.map((leverancier) => (
            <motion.div key={leverancier?.id} variants={itemVariants}>
              <LeverancierCard leverancier={leverancier} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default LeverancierGrid;